/**
 * Spread onto the root element of a report-summary component that is not card-shaped: its grid slot
 * then shrinks to the content instead of holding the card-sized `min-height` every slot gets.
 *
 * Implemented by `.row > div:has(> [data-fit-content])` in `report-summary.module.scss`, so it only
 * has an effect inside the report-summary grid - it does nothing on other screens.
 */
export const FIT_CONTENT_PROP = { "data-fit-content": true } as const;
